<template>
	<form @submit.prevent="submit">
		<div class="row">
			<div class="card col-12" :class="showStrategies() ? 'mb-4' : 'mb-1'">
				<div class="card-body p-4 p-md-5">
					<div>
						Na základe Vašich odpovedí a informácií získaných od Vás v dotazníku
						si Vám dovoľujeme oznámiť, že HABERL Wealth Management, o.c.p., a.s.
						Vás vyhodnotil ako neprofesionálneho klienta a Váš rizikový profil
						ako:
					</div>
					<div v-if="investmentProfile">
						<div class="text-center mt-5 mb-4">
							<h2 class="text-highlighted">{{ investmentProfile.name }}</h2>
						</div>
						<div class="col-12 offset-md-2 col-md-8 text-center mb-3">
							<p class="description">{{ investmentProfile.text }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row px-1 strategies-wrapper" v-if="showStrategies()">
			<div
				class="col-12 col-md-6 col-lg-4 clickable-strategy"
				:class="i > 0 ? 'pl-3' : ''"
				v-for="(strategy, i) in strategies"
				:key="i"
				@click="setClientStrategy(strategy)"
			>
				<div
					class="card mb-4 strategy"
					:class="{
						'selected': selectedStrategy === strategy.id,
					}"
					:style="getStrategyStyles(strategy)"
				>
					<div class="card-header text-center pt-4 pb-3">
						<h4 :style="{ color: '#' + strategy.color }">{{ strategy.name }}</h4>
						<small class="text-uppercase color-medium-gray"
						><b>{{ strategy.subtitle }}</b></small
						>
					</div>
					<div class="card-body text-center p-4 pb-4  mx-2">
						<div class="strategy-text">{{ strategy.text }} <br/></div>
						<a
							:href="strategy.link"
							target="_blank"
							@mouseover="strategy.hover = true"
							@mouseleave="strategy.hover = false"
							@click="strategy.focus = true"
							@blur="strategy.focus = false"
							class="btn btn-outline-primary btn-strategy mt-4 mt-md-2 mt-xl-1 mb-2"
							v-bind:style="{
				color: strategy.hover ? 'white' : '#' + strategy.color,
				borderColor: '#' + strategy.color,
				backgroundColor: strategy.hover
				  ? strategy.color
				  : 'transparent',
				boxShadow: strategy.focus
				  ? '0 0 6px #' + strategy.color
				  : 'unset'
			  }"
						>
							Viac
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="showFeesForm()">
			<div class="card mb-1 col-12">
				<div class="card-body p-4 p-md-5">
					<FeesForm/>
				</div>
			</div>
		</div>
		<div class="row mt-4" v-if="feeTotal">
			<div class="card mb-1 col-12">
				<div class="card-body p-4 p-md-5 text-center">
					Výška vstupného poplatku pre Vašu investíciu je:
					<div class="mb-2">
						<div class="text-center mt-3 mb-4">
							<h2 class="text-highlighted">{{ feeTotal }} €</h2>
						</div>
					</div>

					Vaša plánovaná celková investícia po odpočítaní vstupného poplatku je:
					<div>
						<div class="text-center mt-3 mb-4">
							<h2 class="text-highlighted">{{ investmentTotal }} €</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import FeesForm from "@/components/FeesForm";
import {formatPrice} from "@/utils";

export default {
	name: "onboardingSummary",
	components: {FeesForm},
	mounted() {
		if(this.showStrategies()) {
			this.$emit("can-continue", {value: false});
		} else {
			this.$emit("can-continue", {value: true});
		}
		this.$store.dispatch("onboarding/getInvestmentProfile");
		this.$store.dispatch("onboarding/getStrategies");
        this.$store.dispatch("onboarding/getPersonalInfo");
	},
	computed: {
		investmentProfile() {
			return this.profile[this.$store.state.onboarding.investmentProfile];
		},
		strategies() {
			return this.$store.state.onboarding.strategies;
		},
		selectedStrategy() {
			return this.$store.state.onboarding.selectedStrategy;
		},
		feeTotal() {
			if (this.$store.state.onboarding.feeTotal !== null) {
				return formatPrice(this.$store.state.onboarding.feeTotal);
			}
			return "";
		},
		investmentTotal() {
			if (this.$store.state.onboarding.investmentTotal !== null) {
				return formatPrice(this.$store.state.onboarding.investmentTotal);
			}
			return "";
		},
        personalInfo() {
            return this.$store.state.onboarding.personalInfo;
        },
	},
	data() {
		return {
			profile: {
				2: {
					name: "Konzervatívny",
					text:
						"a investícia do dlhopisov alebo fondov kolektívneho investovania Vám bude vyhovovať najviac"
				},
				3: {
					name: "Vyvážený",
					text:
						"a najviac Vám bude vyhovovať investícia do dlhopisov, fondov kolektívneho investovania a max. 50% investovaných prostriedkov do akcií alebo obdobných investičných nástrojov"
				},
				4: {
					name: "Dynamický",
					text:
						"a najviac Vám bude vyhovovať investícia do akcií alebo obdobných investičných nástrojov prípadne si sám/sama vyberte druh investície"
				}
			},
		};
	},
	methods: {
		showStrategies() {
            if(this.personalInfo.contract_type_id === 2 || this.$store.state.onboarding.questionnaireTypeId === 1) {
                return false;
            }
			return true;

			// return this.$store.state.onboarding.personalInfo.contract_type_id !== 2;
			// return this.$store.state.onboarding.intermediaryPersonFilled;
		},
		showFeesForm() {
			return this.showStrategies() && (
				this.$store.state.onboarding.questionnaireTypeId == 2 ||
				this.$store.state.onboarding.questionnaireTypeId == 3
			);
		},
		setClientStrategy(strategy) {
			this.$store.dispatch('onboarding/setStrategy', strategy);
			if(strategy.id && strategy.id > 0) {
				this.$emit("can-continue", {value: true});
			}
		},
		getStrategyStyles(strategy) {
			let selected = {};

			if (this.selectedStrategy === strategy.id) {
				selected = {
					background: '#' + strategy.color,
				};
			}

			return {
				border: '1px solid #' + strategy.color,
				boxShadow: '0 0 6px #' + strategy.color,
				...selected,
			};
		},
		submit() {
			this.$store.dispatch('onboarding/confirmStrategy');
			this.$parent.nextStep();
		},
	},
};
</script>

<style lang="scss">
.strategies-wrapper {
	width: 100%;
	display: flex;
	justify-content: center;

	.card.strategy {
		cursor: pointer !important;

		&.selected {
			h4 {
				color: #fff !important;
			}

			.color-medium-gray {
				color: darken(#fff, 10%);
			}

			.btn-strategy {
				color: #fff !important;
				border-color: #fff !important;
			}
		}

		.strategy-text {
			height: 120px;

			@include media-breakpoint-down(sm) {
				height: auto;
			}
		}
	}
}
</style>
